<template>
  <div class="partner-logos">
    <div class="wrapper">
      <div class="left">
        <h2>Choose Partner logos layout</h2>
        <p>Select the layout style for partner logos section.</p>
      </div>
      <div class="right">
        <PartnerLogoSelect
          :columnNumber="8"
          :selectedColumnSet="selectedColumnSet"
          @activeSelect="handleActiveSelect"
        />
        <PartnerLogoSelect
          :columnNumber="5"
          :selectedColumnSet="selectedColumnSet"
          @activeSelect="handleActiveSelect"
        />
      </div>
    </div>
    <PartnerLogoGap
      :logosObj="logosObj"
      :selectedColumnSet="selectedColumnSet"
      @partnerLogoSettings="handlePartnerLogoSettings"
    />
    <UploadPartnerLogos
      :dataArr="logosObj.data"
      @partnerLogoImage="handlePartnerLogoImage"
      @emitHeight="handleEmitHeight"
      @emitWidth="handleEmitWidth"
      @dataChange="handleDataChange"
    />
  </div>
</template>

<script>
import PartnerLogoSelect from "./PartnerLogoSelect.vue";
import PartnerLogoGap from "./PartnerLogoGap.vue";
import UploadPartnerLogos from "./UploadPartnerLogos.vue";
export default {
  components: {
    PartnerLogoSelect,
    PartnerLogoGap,
    UploadPartnerLogos,
  },
  props: {
    logosObj: {
      type: Object,
    },
  },
  computed: {
    selectedColumnSet() {
      return this.logosObj.layout === "carousel" ? 5 : 8;
    },
  },
  methods: {
    handleEmitHeight(val) {
    },
    handleEmitWidth(val) {
    },
    handlePartnerLogoImage(obj) {
      this.$emit("partnerLogoImage", obj);
    },
    handlePartnerLogoSettings(payload) {
      this.$emit("partnerLogoSettings", payload);
    },
    handleActiveSelect(data) {
      this.$emit("selectedColumnSet", data);
    },
    handleDataChange (data) {
      this.$emit("dataChange", data);
    }
  },
};
</script>

<style scoped lang='scss'>
.partner-logos {
  max-width: 955px;
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      margin: 30px 0 16px 0;
      h2 {
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        color: #001529;
      }
      p {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #001529;
      }
    }
    .right {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 340px;
      div {
        align-self: flex-start;
      }
    }
  }
}
</style>